import { BasicNode, BasicNodeProps } from "./BasicNode";

const PendingNode = (props: BasicNodeProps) => (
  <BasicNode {...props} pending={true} />
);

export default PendingNode;
